import React from 'react';

import { Svg } from '@rbilabs/universal-components';
import { Path, Rect } from 'react-native-svg';

export const MenuAcceleratorBadgeSvg = () => {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" style={{ width: 24, height: 24 }}>
      <Rect width={24} height={24} rx={12} fill="#FFAA00" />
      <Path
        d="M17.4983 8.97595L16.4795 9.68009L15.4608 10.3842C15.3067 10.4891 15.1269 10.5319 14.9535 10.5105C14.7802 10.4912 14.6132 10.4099 14.487 10.2729L13.5795 9.28415L12.672 8.29535C12.4923 8.09845 12.2461 8 12 8C11.7539 8 11.5077 8.09845 11.328 8.29535L10.4205 9.28415L9.51303 10.2729C9.38676 10.4099 9.21982 10.4912 9.04646 10.5105C8.8731 10.5298 8.69332 10.4891 8.53922 10.3842L7.52046 9.68009L6.50171 8.97595C6.2406 8.79617 5.9324 8.80901 5.69912 8.94813C5.46583 9.08725 5.30531 9.34835 5.33741 9.66511L5.63277 12.5972L5.92812 15.5294C5.94738 15.7199 6.03727 15.8868 6.16997 16.0067C6.30266 16.1265 6.47816 16.1993 6.67079 16.1993H12H17.3292C17.5197 16.1993 17.6973 16.1265 17.83 16.0067C17.9627 15.8868 18.0526 15.7199 18.0719 15.5294L18.3672 12.5972L18.6626 9.66511C18.6947 9.34835 18.5342 9.08725 18.3009 8.94813C18.0654 8.80901 17.7594 8.79617 17.4983 8.97595Z"
        fill="#502314"
      />
    </Svg>
  );
};
